import AgentCooperationDecorator from "./AgentCooperationDecorator";
import AgentProductDealDecorator from "./AgentProductDealDecorator";
import AgentDealPricingDecorator from "./AgentDealPricingDecorator";

export default class AgentCooperationFullDecorator extends AgentCooperationDecorator {
  transformData(data) {
    return super.transformData({
      ...data,
      agent_product_deals: data.agent_product_deals.map((x) => new AgentProductDealDecorator(x)),
      agent_deal_pricings: data.agent_deal_pricings.map((x) => new AgentDealPricingDecorator(x)),
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/AgentCooperationFullDecorator.js